import { APP_INITIALIZER, NgModule } from '@angular/core';

import { environment } from '@env/environment';
import { LogLevel } from './services/logger/config/log-level.enum';
import { LOGGER_CONFIG } from './services/logger/config/logger-config';
import { initializeApp } from './factories/initialize.factory';
import { reportingInterceptor } from './interceptores/reporting.interceptor';
import { tokenInterceptor } from './interceptores/token.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRetryInterceptor } from './interceptores/http-retry.interceptor';
import { ChunkErrorInterceptor } from './interceptores/chunk-error.interceptor';
import { AuthService } from './services/auth/auth.service';

@NgModule({
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AuthService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRetryInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ChunkErrorInterceptor, multi: true },
    reportingInterceptor,
    tokenInterceptor,
    {
      provide: LOGGER_CONFIG,
      useValue: environment.production ? LogLevel.WARN : LogLevel.VERBOSE,
    },
  ],
})
export class CoreModule {}
